import { GridSize } from "@material-ui/core";
import { Grid, TextField, MenuItem } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { ChangeEvent } from "react";
import {
  loadMoreSugestions,
  authorSuggestions,
  stepSleepOptions,
  nextPageSuggestions,
  webCrawlerContainerSuggestions,
  webCrawlernextPageSuggestions,
} from "./SourceDetails-utils";
import {
  ImportMode,
  PaginationStrategyOption,
  NavigationMode,
} from "@authory-packages/core";

type SourceExtractionAutoCompleteProps = {
  importMode: ImportMode;
  smSize: GridSize;
  nextPage: string;
  onNextPageChange: (e: ChangeEvent<{}>, value: any) => void;
  loadMore: string;
  onLoadMoreChange: (e: ChangeEvent<{}>, value: any) => void;
  authorQuery: string;
  onAuthorQueryChange: (e: ChangeEvent<{}>, value: any) => void;
  stepSleep: number;
  onStepSleepChange: (e: ChangeEvent<{}>, value: any) => void;
  disabled: boolean;
  onInputChange: (e: ChangeEvent<HTMLInputElement>) => void;
  containerXPath?: string;
  onContainerXPathChange: (e: ChangeEvent<{}>, value: any) => void;
  paginationStrategy?: PaginationStrategyOption;
  elementXPath?: string;
  onElementXPathChange: (e: ChangeEvent<{}>, value: any) => void;
  navigationMode?: NavigationMode;
};

export const SourceExtractionAutoComplete = ({
  importMode,
  smSize,
  nextPage,
  onNextPageChange,
  loadMore,
  onLoadMoreChange,
  authorQuery,
  onAuthorQueryChange,
  stepSleep,
  onStepSleepChange,
  disabled,
  onInputChange,
  containerXPath,
  onContainerXPathChange,
  paginationStrategy,
  elementXPath,
  onElementXPathChange,
  navigationMode,
}: SourceExtractionAutoCompleteProps) => {
  if (importMode === ImportMode.SearchEngine) return <></>;

  if (importMode === ImportMode.WebCrawler) {
    return (
      <>
        <Grid item sm={smSize}>
          <Autocomplete
            freeSolo
            size="small"
            value={containerXPath || ""}
            disabled={disabled}
            onChange={onContainerXPathChange}
            options={webCrawlerContainerSuggestions.map(
              (option) => option.xpath,
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                label="Container xPath"
                placeholder="Container xPath"
                variant="outlined"
                name="containerXPath"
                value={containerXPath || ""}
                onChange={onInputChange}
                InputProps={{ ...params.InputProps }}
              />
            )}
          />
        </Grid>
        <Grid item sm={smSize}>
          <TextField
            select
            fullWidth
            size="small"
            variant="outlined"
            label="Pagination Strategy"
            name="paginationStrategy"
            value={paginationStrategy || PaginationStrategyOption.NextPage}
            onChange={onInputChange}
            disabled={disabled}
          >
            <MenuItem value={PaginationStrategyOption.NextPage}>
              NextPage
            </MenuItem>
            <MenuItem value={PaginationStrategyOption.Scroll}>Scroll</MenuItem>
          </TextField>
        </Grid>
        <Grid item sm={smSize}>
          <Autocomplete
            freeSolo
            size="small"
            value={elementXPath || ""}
            disabled={disabled}
            onChange={onElementXPathChange}
            options={webCrawlernextPageSuggestions.map(
              (option) => option.xpath,
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                placeholder="Element xPath"
                variant="outlined"
                label="Element xPath"
                name="elementXPath"
                value={elementXPath || ""}
                onChange={onInputChange}
                InputProps={{ ...params.InputProps }}
              />
            )}
          />
        </Grid>
        <Grid item sm={smSize}>
          <TextField
            select
            fullWidth
            size="small"
            variant="outlined"
            label="Navigation Mode"
            name="navigationMode"
            value={navigationMode || NavigationMode.Normal}
            onChange={onInputChange}
            disabled={disabled}
          >
            <MenuItem value={NavigationMode.Normal}>Normal</MenuItem>
            <MenuItem value={NavigationMode.Slow}>Slow</MenuItem>
          </TextField>
        </Grid>
      </>
    );
  }

  return (
    <>
      <Grid item sm={smSize}>
        <Autocomplete
          freeSolo
          size="small"
          value={nextPage}
          disabled={disabled}
          onChange={onNextPageChange}
          options={nextPageSuggestions.map((option) => option.xpath)}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Next Page"
              variant="outlined"
              name="nextPage"
              value={nextPage}
              onChange={onInputChange}
              InputProps={{ ...params.InputProps }}
            />
          )}
        />
      </Grid>
      <Grid item sm={smSize}>
        <Autocomplete
          freeSolo
          size="small"
          disabled={disabled}
          value={loadMore}
          onChange={onLoadMoreChange}
          options={loadMoreSugestions.map((option) => option.xpath)}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Load more"
              variant="outlined"
              name="loadMore"
              value={loadMore}
              onChange={onInputChange}
              InputProps={{ ...params.InputProps }}
            />
          )}
        />
      </Grid>
      <Grid item sm={smSize}>
        <Autocomplete
          freeSolo
          size="small"
          disabled={disabled}
          value={authorQuery}
          options={authorSuggestions.map((option) => option.xpath)}
          onChange={onAuthorQueryChange}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Author"
              variant="outlined"
              name="authorQuery"
              value={authorQuery}
              onChange={onInputChange}
              InputProps={{ ...params.InputProps }}
            />
          )}
        />
      </Grid>
      <Grid item sm={smSize}>
        <Autocomplete
          size="small"
          disabled={disabled}
          disableClearable
          options={stepSleepOptions}
          getOptionLabel={(option) => {
            switch (option) {
              case 6000:
                return "High";
              case 1000:
                return "Normal";
              case 100:
                return "Low";
              case 0:
                return "None";
              default:
                return "";
            }
          }}
          value={stepSleep}
          onChange={onStepSleepChange}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Step Sleep"
              variant="outlined"
              InputProps={{ ...params.InputProps }}
            />
          )}
        />
      </Grid>
    </>
  );
};
